module.exports = __webpack_public_path__ + "img/tuev-logo.4a884e4f.svg";